module.exports = __webpack_public_path__ + "static/media/BannerD2.27ee631a.png";